<template>
  <v-dialog v-model="editDialog" max-width="500px" persistent scrollable>
    <v-card v-if="selectedItem != null">
      <v-toolbar dark>
        <v-toolbar-title class="headline">Edit User</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)" v-if="!saving_data"
          >close</v-icon
        >
      </v-toolbar>
      <v-card-text style="height: auto">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row>
            <v-flex xs2 class="mr-2">
              <v-select
                :items="country_tel"
                v-model="selectedItem.user_country_tel"
                label="Select"
              ></v-select>
            </v-flex>
            <v-flex xs10 class="ml-2">
              <v-text-field
                v-model="selectedItem.user_tel"
                label="Tel."
                :rules="[telValid.leng, telValid.already, telValid.required]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6 class="mr-2">
              <v-text-field
                v-model="selectedItem.user_first_name"
                label="First name"
                :rules="[nameValid.max, nameValid.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="ml-2">
              <v-text-field
                v-model="selectedItem.user_last_name"
                label="Last name"
                :rules="[nameValid.max, nameValid.required]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-text-field
            v-model="selectedItem.user_email"
            label="Email"
            :rules="[
              emailValid.email,
              emailValid.required,
              emailValid.already,
              nameValid.max,
            ]"
          ></v-text-field>
          <v-layout row>
            <v-flex xs6 class="mr-2">
              <v-select
                :items="verifyEmail"
                item-text="name"
                item-value="value"
                v-model="selectedItem.user_verify"
                label="Verify email"
                :rules="
                  typeof selectedItem.user_verify != 'boolean'
                    ? [roleValid.required]
                    : []
                "
              ></v-select>
            </v-flex>
            <v-flex xs6 class="ml-2">
              <v-select
                :items="RoleItems"
                item-text="name"
                item-value="value"
                v-model="selectedItem.user_role"
                label="Role"
                :rules="[roleValid.required]"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6 class="mr-2">
              <v-radio-group
                v-model="user_province_type"
                @change="selectedItem.user_province = []"
              >
                <v-radio :label="'All'" :value="1"></v-radio>
                <v-radio :label="'Select province'" :value="2"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs6 class="ml-2">
              <v-autocomplete
                v-model="selectedItem.user_province"
                :items="province_list"
                outlined
                name="province"
                :loading="loadingProvince"
                item-text="province_name_en"
                item-value="province_name_en"
                dense
                chips
                small-chips
                label="Select province"
                multiple
                v-if="user_province_type == 2"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <div class="line-changepass"></div>
          <v-text-field
            v-model="password1"
            :append-icon="show1 ? 'visibility_off' : 'visibility'"
            :type="show1 ? 'text' : 'password'"
            autocomplete="new-password"
            label="New Password"
            hint="At least 6 characters and No more than 24 characters"
            @click:append="show1 = !show1"
          ></v-text-field>
          <v-text-field
            v-model="password2"
            :append-icon="show2 ? 'visibility_off' : 'visibility'"
            :type="show2 ? 'text' : 'password'"
            autocomplete="new-password"
            label="Confirm New Password"
            hint="At least 6 characters and No more than 24 characters"
            @click:append="show2 = !show2"
          ></v-text-field>
          <div v-if="passwordMatch == false">Password Not match ...</div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat :disabled="saving_data" @click="cancel()"
          >Cancel</v-btn
        >
        <v-btn
          color="green"
          flat
          :disabled="isEditStaff || saving_data"
          :loading="saving_data"
          @click="save()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["selectedItem", "editDialog", "originalUser"],
  data() {
    return {
      saving_data: false,
      loadingProvince: false,
      country_tel: ["+66"],
      passwordMatch: true,
      user_province_type: 1,
      selected: [],
      verifyEmail: [
        {
          name: "verified",
          value: true,
        },
        {
          name: "not verified",
          value: false,
        },
      ],
      password1: "",
      password2: "",
      show1: false,
      show2: false,
      valid: true,
      telValid: {
        required: (value) => !!value || "Required.",
        leng: (v) => v.length == 9 || "9 characters",
        already: (a) => !this.telAlready(a) || "Already in use",
      },
      nameValid: {
        required: (value) => !!value || "Required.",
        max: (v) => v.length <= 55 || "Min 55 characters",
      },
      emailValid: {
        already: (a) => !this.emailAlready(a) || "Already in use",
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      roleValid: {
        required: (value) => (!!value && value !== 0) || "Required.",
      },
    };
  },
  watch: {
    async editDialog() {
      if (this.editDialog == true) {
        if (this.selectedItem.user_province) {
          if (
            this.selectedItem.user_province.length > 0 &&
            this.selectedItem.user_province[0] != "all"
          ) {
            this.user_province_type = 2;
          }
        }
        this.loadingProvince = true;
        await this.$store.dispatch("fetchProvinceBack/getData");
        this.loadingProvince = false;
      } else {
        this.user_province_type = 1;
        this.password1 = "";
        this.password2 = "";
      }
    },
    password1() {
      if (this.password1.length > 5 && this.password1.length < 25) {
        if (this.password1 != this.password2) {
          this.passwordMatch = false;
        } else {
          this.passwordMatch = true;
        }
      } else {
        this.passwordMatch = true;
      }
    },
    password2() {
      if (this.password2.length > 5 && this.password2.length < 25) {
        if (this.password1 != this.password2) {
          this.passwordMatch = false;
        } else {
          this.passwordMatch = true;
        }
      } else {
        this.passwordMatch = true;
      }
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.fetchUserBack.userData,
      // province_list: state => state.fetchProvinceBack.provinceData
    }),
    ...mapGetters({
      isEditStaff: "isEditStaff",
      province_list: "fetchProvinceBack/provinceSplited",
    }),
    RoleItems() {
      if (
        this.$store.state.permission.permission_name.toLowerCase() == "root"
      ) {
        return [
          {
            name: "SuperAdmin",
            value: 1,
          },
          {
            name: "Admin",
            value: 2,
          },
          {
            name: "Viewer(Manager)",
            value: 3,
          },
          {
            name: "Callcenter",
            value: 4,
          },
          {
            name: "Customer",
            value: 6,
          },
          {
            name: "RiderManager",
            value: 8,
          },
          {
            name: "Accounting",
            value: 9,
          },
          {
            name: "Marketing",
            value: 10,
          },
          {
            name: "AdminLaborStore",
            value: 11,
          },
          {
            name: "Root",
            value: 12,
          },
        ];
      } else {
        return [
          {
            name: "SuperAdmin",
            value: 1,
          },
          {
            name: "Admin",
            value: 2,
          },
          {
            name: "Viewer(Manager)",
            value: 3,
          },
          {
            name: "Callcenter",
            value: 4,
          },
          {
            name: "Customer",
            value: 6,
          },
          {
            name: "RiderManager",
            value: 8,
          },
          {
            name: "Accounting",
            value: 9,
          },
          {
            name: "Marketing",
            value: 10,
          },
          {
            name: "AdminLaborStore",
            value: 11,
          },
        ];
      }
    },
  },
  methods: {
    telAlready(a) {
      let index = this.userData.indexOf(this.selectedItem);
      let check = 0;
      for (let key in this.userData) {
        if (key != index) {
          if (a == this.userData[key].user_tel) {
            check = 1;
          }
        }
      }
      if (check == 0) {
        return false;
      } else if (check == 1) {
        return true;
      }
    },
    emailAlready(a) {
      let index = this.userData.indexOf(this.selectedItem);
      let check = 0;
      for (let key in this.userData) {
        if (key != index) {
          if (a == this.userData[key].user_email) {
            check = 1;
          }
        }
      }
      if (check == 0) {
        return false;
      } else if (check == 1) {
        return true;
      }
    },
    cancel() {
      Object.assign(this.selectedItem, this.originalUser);
      this.$emit("setOriginal", null);
      this.$emit("setDialog", false);
    },
    async save() {
      if (this.$refs.form.validate()) {
        let index = this.userData.indexOf(this.selectedItem);
        this.$store.commit("fetchUserBack/editing", index);
        if (this.user_province_type == 1) {
          this.selectedItem.user_province = ["all"];
        }
        const sendData = {
          user_country_tel: this.selectedItem.user_country_tel,
          user_email: this.selectedItem.user_email,
          user_facebook_id: this.selectedItem.user_facebook_id,
          user_first_name: this.selectedItem.user_first_name,
          user_id: this.selectedItem.user_id,
          user_last_name: this.selectedItem.user_last_name,
          user_role: this.selectedItem.user_role,
          user_sum_point: this.selectedItem.user_sum_point,
          user_tel: this.selectedItem.user_tel,
          user_type: this.selectedItem.user_type,
          user_province: this.selectedItem.user_province,
          user_verify: this.selectedItem.user_verify,
        };
        this.saving_data = true;
        let checkSuccess = await this.$store.dispatch(
          "fetchUserBack/editUser",
          sendData
        );
        this.saving_data = false;
        if (checkSuccess == "error") {
          // Object.assign(this.selectedItem, this.originalUser);
        } else {
          this.$emit("setDialog", false);
          this.$emit("setOriginal", null);
          if (this.password1.length > 5 && this.password1.length < 25) {
            if (this.passwordMatch == true) {
              const sendData = {
                user_id: this.selectedItem.user_id,
                new_password: this.password2,
              };
              this.$store.dispatch(
                "fetchUserBack/changePasswordUser",
                sendData
              );
            }
          }

          this.password1 = "";
          this.password2 = "";
        }
      }
    },
  },
};
</script>

<style>
.line-changepass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-changepass:after {
  content: "Change Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
